import Sidebar from "../../../components/partials/Sidebar";
import Header from "../../../components/partials/Header";
import Breadcrumb from "../../../components/Breadcrumb";
import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Pagination from "../../../components/Pagination";
import "./style.css";
import filter from "../../../images/icons/filter.png";
import editIcon from "../../../images/icons/edit.png";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import Modal from "react-bootstrap/Modal";
import viewIcon from "../../../images/view.png";
import GowdonViews from "./view";
import GowdonAdd from "./Add";
import GowdonEdit from "./Edit";
import {
  apiCancelGodown,
  apiListBranch,
  apiListGodown,
} from "../../../api/master";
import { apiCity, apiState } from "../../../api/stateAndCity";
import Swal from "sweetalert2";
import CommonAsyncSelect from "../../../components/CommonAsyncSelect";
import config from "../../../config";
import $ from "jquery";
import { removeEmptyFields } from "../../../utils";

function GodownList() {
  const initialState = {
    godown_name: "",
    is_acitve: "",
  };

  const [user, setUser] = useState({});

  // useEffect(function () {
  //   if (localStorage.getItem("inventory")) {
  //     setUser(JSON.parse(localStorage.getItem("inventory")).userData);
  //   }
  // }, []);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [showId, setShowId] = useState(0);
  const [editId, setEditId] = useState("");
  const [selecteBranch, setSelecteBranch] = useState("");
  console.log("selecteBranchselecteBranch", selecteBranch);

  const [formInputs, setFormInputs] = useState(initialState);
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(0);

  async function changeStatus(godown_id, status) {
    let target = window.event.target;
    let oldText = target.innerText;
    target.innerText = "Updating...";
    await apiCancelGodown({ godown_id: godown_id, is_active: status })
      .then((data) => {
        setError("");
      })
      .catch((err) => {
        setError(err.response.data.data.message);
        setTimeout(function () {
          setError("");
        }, 3000);
      })
      .finally(() => {
        target.innerText = oldText;
        getList(filtersVisible);
      });
  }

  async function getList(isFilter = true, pageNo = null, id = null) {
    let json = { paginate: 1, page_no: (pageNo || currentPage) - 1 };
    json.branch_id = id;

    if (user.role_id === 2) {
      json.branch_id = selecteBranch?.branch_id;
    }

    if (isFilter) {
      json = { ...json, ...formInputs };
    }
    json = removeEmptyFields(json);
    await apiListGodown(json)
      .then((data) => {
        setCurrentPage(pageNo || currentPage);
        setIsSubmit(false);
        setList(data.data.data.list);
        setIsLoading(false);
        setTotalPage(data.data.data.count);
      })
      .catch(function (err) {
        setIsSubmit(false);

        Swal.fire({
          icon: "error",
          title: "Error",
          text: err.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      });
  }

  let id = null;
  useEffect(
    function () {
      if (localStorage.getItem("inventory")) {
        setUser(JSON.parse(localStorage.getItem("inventory")).userData);
        id = JSON.parse(localStorage.getItem("inventory")).userData
          ?.branch_data[0]?.branch_id;
      }

      getList(filtersVisible, null, id);
    },
    [currentPage]
  );

  function handleInputs(e) {
    setFormInputs({ ...formInputs, [e.target.id]: e.target.value });
  }

  function handleFilterVisibility() {
    if (filtersVisible) {
      setFiltersVisible(false);
      setFormInputs(initialState);
    } else {
      setFiltersVisible(true);
    }
  }
  const [branch, setBranchValue] = useState([]);

  async function getBranch() {
    await apiListBranch({ paginate: 0 }).then((result) => {
      const branches = result.data.data.list;
      setBranchValue(branches);
    });
  }

  useEffect(() => {
    getBranch();
  }, []);

  const branchOptions = branch.reduce((acc, { branch_id, branch_name }) => {
    acc[branch_id] = branch_name;
    return acc;
  }, {});

  console.log("branchOptions", branchOptions);

  return (
    <>
      <div
        className="d-flex min-vh-100 main-Wrapper"
        style={{ background: "#DAE5FF" }}
      >
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />
          <main className="bg-white rounded-4" id="buyer">
            <div className="container-fluid p-2">
              <div className="row">
                <div className="col">
                  <Breadcrumb path={["Godown"]} />
                </div>
                <div
                  className="col text-end"
                  style={{
                    display: "flex",
                    alignItems: "end",
                    justifyContent: "end",
                  }}
                >
                  <Tippy content="Filter">
                    <img
                      onClick={() => handleFilterVisibility()}
                      src={filter}
                      className="img-fluid me-3"
                      alt=""
                      role="button"
                      style={{ width: "2rem" }}
                    />
                  </Tippy>

                  {user.role_id === 3 || user.role_id === 4 ? (
                    ""
                  ) : (
                    <Link
                      onClick={(v) => {
                        handleShow();
                        setShowId(1);
                      }}
                      className="btn btn-primary px-4 py-2"
                      style={{
                        height: "33px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      Add Godown
                    </Link>
                  )}
                </div>
              </div>

              {filtersVisible && (
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    setIsSubmit(true);
                    if (localStorage.getItem("inventory")) {
                      setUser(
                        JSON.parse(localStorage.getItem("inventory")).userData
                      );
                      id = JSON.parse(localStorage.getItem("inventory"))
                        .userData?.branch_data[0]?.branch_id;
                    }
                    currentPage > 1 ? setCurrentPage(1) : getList(true, 1, id);
                  }}
                  autoComplete="off"
                >
                  <div className="row" id="buyerAdd">
                    <div className="col">
                      <label htmlFor="godown_name">Godown Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="godown_name"
                        value={formInputs.godown_name}
                        onChange={handleInputs}
                      />
                    </div>
                    {user.role_id === 2 && (
                      <div className="col-md">
                        <label htmlFor="state_id">Branch</label>

                        <CommonAsyncSelect
                          getOptionLabel={(o) => o.branch_name}
                          placeholder="Enter atleast 3 character"
                          getOptionValue={(o) => o.branch_id}
                          noOptionsMessage={() => null}
                          loadOptions={async (inputValue, callback) => {
                            if (inputValue.length > 2) {
                              await $.post(
                                `${config.apiUrl}/branch/listBranch`,
                                JSON.stringify({
                                  paginate: 0,
                                  is_active: 1,
                                  branch_name: inputValue,
                                }),
                                (res) => {
                                  callback(res?.data?.list || []);
                                }
                              );
                            } else {
                              callback([]);
                            }
                          }}
                          value={selecteBranch}
                          // isMulti={true}
                          onChange={(e) => {
                            setSelecteBranch(e);
                          }}
                          components={{
                            IndicatorsContainer: () => null,
                          }}
                          styles={{
                            control: (baseStyles) => ({
                              ...baseStyles,
                              minHeight: "0px",
                              height: "37px",
                            }),
                            valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                            input: (baseStyles) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                              marginTop: "0px",
                              marginBottom: "0px",
                              gridTemplateColumns: "0 100%",
                              height: "37px",
                            }),
                            dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                            option: (baseStyles) => ({
                              ...baseStyles,
                              paddingTop: "0px",
                              paddingBottom: "0px",
                            }),
                          }}
                          classNamePrefix="react-select"
                          tabSelectsValue
                        />
                      </div>
                    )}

                    <div className="col-md">
                      <label htmlFor="default_godown">Status</label>
                      <select
                        className="form-select"
                        value={formInputs.is_active}
                        onChange={handleInputs}
                        id="is_active"
                      >
                        <option value="">All</option>
                        <option value="1">Active</option>
                        <option value="0">In-Active</option>
                      </select>
                    </div>

                    <div
                      className="col-md-4 mt-auto"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "end",
                        float: "right",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmit}
                        style={{
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        {isSubmit && (
                          <span className="spinner-border spinner-border-sm me-2"></span>
                        )}
                        Search
                      </button>
                      <button
                        className="btn btn-primary rounded-3 px-3 ms-2"
                        type="button"
                        onClick={(e) => {
                          setFormInputs(initialState);
                          setSelecteBranch("");
                          if (localStorage.getItem("inventory")) {
                            setUser(
                              JSON.parse(localStorage.getItem("inventory"))
                                .userData
                            );
                            id = JSON.parse(localStorage.getItem("inventory"))
                              .userData?.branch_data[0]?.branch_id;
                          }
                          currentPage > 1
                            ? setCurrentPage(1)
                            : getList(false, 1, id);
                        }}
                        style={{
                          background: "#4263eb",
                          fontSize: "14px",
                          height: "33px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          float: "right",
                        }}
                      >
                        Clear Filters
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {error && (
                <div className="row mt-3">
                  <div className="col">
                    <div
                      className={`alert alert-danger py-1 small`}
                      role="alert"
                    >
                      {error || ""}
                    </div>
                  </div>
                </div>
              )}

              <div className="row mb-4">
                <div className="col">
                  <table className={`table ${error ? "my-1" : "mt-4"} rounded`}>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Godown Name</th>
                        <th>Godown Address</th>
                        {user.role_id === 2 && <th>Branch Name</th>}
                        <th>Status</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {(isLoading || list.length == 0) && (
                        <tr>
                          <td colSpan="9" className="text-center">
                            {isLoading ? "Loading..." : "No Records"}
                          </td>
                        </tr>
                      )}
                      {list.map((v, i) => (
                        <tr key={`bl_` + i}>
                          <td>{currentPage * 10 - 10 + i + 1}</td>
                          <td>{v.godown_name}</td>
                          <td>{v.godown_address}</td>
                          {user.role_id === 2 && (
                            <td>
                              {(() => {
                                const branchNames =
                                  v.branch_id
                                    ?.map((id) => branchOptions[id])
                                    .filter((name) => name !== undefined)
                                    .join(", ") || "N/A";

                                return branchNames.length > 45 ? (
                                  <Tippy content={branchNames}>
                                    <span style={{ cursor: "pointer" }}>
                                      {branchNames.slice(0, 45) + "..."}
                                    </span>
                                  </Tippy>
                                ) : (
                                  branchNames
                                );
                              })()}
                            </td>
                          )}
                          <td>
                            {user.role_id === 3 ? (
                              <Tippy disabled>
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            ) : (
                              <Tippy content="Change Status">
                                {v.is_active ? (
                                  <span
                                    className="badge text-bg-success"
                                    role="button"
                                    onClick={() => changeStatus(v.godown_id, 0)}
                                  >
                                    Active
                                  </span>
                                ) : (
                                  <span
                                    className="badge text-bg-danger"
                                    role="button"
                                    onClick={() => changeStatus(v.godown_id, 1)}
                                  >
                                    In-Active
                                  </span>
                                )}
                              </Tippy>
                            )}
                          </td>
                          <td>
                            <Tippy content="View" trigger="mouseenter">
                              <a
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  setEditId(v);
                                  handleShow();
                                  setShowId(3);
                                }}
                              >
                                <img
                                  src={viewIcon}
                                  className="img-fluid me-2"
                                  alt=""
                                />
                              </a>
                            </Tippy>
                            {user.role_id === 3 || user.role_id == 4 ? (
                              ""
                            ) : (
                              <Tippy content="Edit" trigger="mouseenter">
                                <Link
                                  onClick={() => {
                                    setEditId(v);
                                    handleShow();
                                    setShowId(2);
                                  }}
                                  className={`link-info ${
                                    v.is_active ? "" : "d-none"
                                  }`}
                                >
                                  <img
                                    src={editIcon}
                                    className="img-fluid me-2"
                                    alt=""
                                  />
                                </Link>
                              </Tippy>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.ceil(totalPage / 10)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
              <Modal
                show={show}
                onHide={handleClose}
                keyboard={false}
                backdrop="static"
              >
                {showId == 1 ? (
                  <GowdonAdd id={editId} list={getList} hide={handleClose} />
                ) : showId == 2 ? (
                  <GowdonEdit id={editId} list={getList} hide={handleClose} />
                ) : showId == 3 ? (
                  <GowdonViews id={editId} list={getList} hide={handleClose} />
                ) : null}
              </Modal>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default GodownList;
